var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2458 4.5358L5.9558 0.295798C5.76803 0.106486 5.51244 0 5.2458 0C4.97916 0 4.72357 0.106486 4.5358 0.295798L0.295798 4.5358C0.106486 4.72357 0 4.97916 0 5.2458C0 5.51244 0.106486 5.76803 0.295798 5.9558C0.685836 6.34352 1.31576 6.34352 1.7058 5.9558L5.2458 2.4158L8.7858 5.9558C8.97206 6.14054 9.22346 6.24469 9.4858 6.2458C9.7516 6.24734 10.0071 6.14298 10.1958 5.9558C10.3919 5.77479 10.5075 5.52291 10.5169 5.25622C10.5262 4.98953 10.4287 4.73015 10.2458 4.5358Z",
    fill: "#243342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlack);
export default __webpack_public_path__ + "static/media/arrow-up-black.1b7eed0916dbede4ccdcbe985f394438.svg";
export { ForwardRef as ReactComponent };